//settings delle gallery TINY SLIDER
import { tns } from 'tiny-slider/src/tiny-slider';
var slider = tns({
    container: '.galleryAboutUs',
    loop: true,
    items: 1,
    nav: false,
    autoplay: false,
    speed: 400,
    autoplayButtonOutput: false,
    mouseDrag: true,
    lazyload: true,
    controlsContainer: "#customize-controls",

    "responsive": {
        "568": {
            "items": 1,
        },

        "767": {
            "items": 2,
        },

        "992": {
            "items": 3,
        },
    },
});
